export { DoctorDialogComponent as DialogComponent } from './components/doctor-dialog.component';
export { DoctorFormComponent as FormComponent } from './components/doctor-form.component';
export { DoctorMainComponent as MainComponent } from './components/doctor-main.component';
export { DoctorSpecialtiesDialogComponent as SpecialtiesDialogComponent } from './components/doctor-specialties-dialog.component';
